module.exports = __webpack_public_path__ + "img/1547630527.3ae70022.jpg";